import React, { useState } from "react"
import PropTypes from "prop-types"

import { MAX_RATING } from "../static"

const StarRating = ({ label, value, onChange }) => {
  const [hover, setHover] = useState(0)

  return (
    <div className="av-stars">
      <div className="av-stars-label">{label}</div>
      <div className="av-stars-row" onMouseLeave={() => setHover(0)}>
        {Array.from({ length: MAX_RATING }, (unused, index) => index + 1).map(
          punto => (
            <button
              key={punto}
              type="button"
              className={`av-star${
                value >= punto || hover >= punto ? " is-on" : ""
              }`}
              onClick={() => onChange(value === punto ? 0 : punto)}
              onMouseEnter={() => setHover(punto)}
            >
              ★
            </button>
          )
        )}
      </div>
    </div>
  )
}

StarRating.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export const StarsReadOnly = ({ value }) => (
  <div className="av-stars-mini">
    {Array.from({ length: MAX_RATING }, (unused, index) => index + 1).map(
      punto => (
        <span
          key={punto}
          className={`av-star-mini${value >= punto ? " is-on" : ""}`}
        >
          ★
        </span>
      )
    )}
  </div>
)

StarsReadOnly.propTypes = {
  value: PropTypes.number,
}

export default StarRating
